import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { SearchForm } from './SearchForm';
import { FieldGroup } from './FieldGroup';
import { FormControl } from './Controls/FormControl';
import { FAIcon } from '../fa-icon';
import classNames from 'classnames';
import { isEqual } from 'lodash';

export const SearchComponent = props => {
  const {
    disabled,
    name = 'searchValue',
    searchAction,
    valueChangeDelay,
    wrapperClass,
    value,
    ...controlProps
  } = props;
  const inputProps = { ...controlProps, className: classNames('ui-default', 'regular', controlProps?.className) };
  const wrapperClasses = classNames('search-wrapper', wrapperClass, { disabled });
  const prevValueRef = useRef({ searchValue: value });

  const onSearch = value => {
    if (!isEqual(value, prevValueRef.current) && typeof searchAction === 'function') {
      searchAction(value);
      prevValueRef.current = value;
    }
  };

  return (
    <SearchForm
      className={wrapperClasses}
      searchAction={onSearch}
      valueChangeDelay={valueChangeDelay}
      defaultValues={{ searchValue: value }}
    >
      <div className="search-icon">
        <FAIcon icon="search" />
      </div>
      <FieldGroup className="search-input">
        <FormControl name={name} disableSubmit={true} disabled={disabled} {...inputProps} />
      </FieldGroup>
    </SearchForm>
  );
};

SearchComponent.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  searchAction: PropTypes.func.isRequired,
  value: PropTypes.object,
  valueChangeDelay: PropTypes.number,
  wrapperClass: PropTypes.string,
  placeholder: PropTypes.string,
};
